// White
const white_color1 = 'white';
const white_color2 = (opacity: number) => `rgba(251,251,251,${opacity})`; //#FBFBFB

// Red
const red_error1 = '#FFA8AF';
const red_error2 = '#FF5F6B';

// Blue
const blue_main = (opacity: number) => `rgba(0,43,86,${opacity})`;
const blue_second = (opacity: number) => `rgba(152,197,242,${opacity})`;
const blue_active = '#1E96FC';
const blue_inactive = (opacity: number) => `rgba(187,223,254,${opacity})`;
const blue_third = '#7AB2E2';
const blue_fourth = 'aliceblue';

// Black
const black_text_color1 = '#696767';
const black_text_color2 = '#818181';
const black_text_color3 = '#C4C4C4';
const black_text_color4 = '#B0B0B0';
const black_back_color5 = '#ECECEC';
const black_shadow_1 = 'rgba(0, 0, 0, 0.25)';

// Green 
const green_color1 = '#6AEB8F';

// Transparent
const transparent_color1 = 'transparent';

// Yellow 
const yellow_colo1 = 'rgba(255, 192, 30, 1)';


export const COLORS = {
    blue_main,
    blue_second,
    blue_active,
    blue_inactive,
    blue_fourth,
    blue_third,
    white_color1,
    white_color2,
    red_error1,
    red_error2,
    black_text_color1,
    black_text_color2,
    black_text_color3,
    black_text_color4,
    black_back_color5,
    black_shadow_1,
    green_color1,
    yellow_colo1,
    transparent_color1
}